import Navbar from "./Components/Navbar";
import Body from "./Components/Body";

const Home = () => {
  return (
    <div>
      <Navbar currentItem="home" />
      <Body />
    </div>
  );
};

export default Home;
